import { css } from 'linaria';
import { useTranslation } from 'next-i18next';
const partnerStyles = "pkyzfxz";
const overlineStyles = "o179acbt";
export function Partner({
  partnerInfo
}) {
  const {
    t
  } = useTranslation();
  const type = partnerInfo.type;
  if (!type) return null;
  const partnerTypes = {
    PARTNERED: t('partner:partner-copy', 'In partnership with'),
    SPONSORED: t('partner:sponsor-copy', 'Brought to you by')
  };
  const attribution = partnerTypes[type] || '';
  return <div className={partnerStyles}>
      <div>{attribution}</div>
      <a href={partnerInfo.url} target="_blank" rel="noopener noreferrer">
        <img src={partnerInfo.imageUrl} alt={partnerInfo.name} />
      </a>
    </div>;
}
export function PartnerOverline({
  partnerType
}) {
  const {
    t
  } = useTranslation();
  if (!partnerType) return null;
  const partnerTypes = {
    PARTNERED: t('partner:partner-overline', 'From our partners'),
    SPONSORED: t('partner:sponsor-overline', 'Sponsored')
  };
  const overline = partnerTypes[partnerType] || '';
  return <div className={overlineStyles}>{overline}</div>;
}

require("./partner.linaria.module.css!=!../../../node_modules/linaria/lib/outputCssLoader.js?cacheProvider=!./partner.js");